import React, { useState, useContext, useEffect, Children } from "react";
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  BackHandler,
} from "react-native";
import NavBar from "../NavBar/NavBar";
import {
  handleGetEmpDetails,
  handleAPI,
  handleStartNewLoan,
  updateWebURL,
  handleLogDWCallToActionEventParent,
  log,
  removeDuplicates,
  handleSessionCheck,
  queryStringToObject,
  handleUserDetails,
} from "../accessories/CommonFunctions.js";
import CustomText from "../accessories/CustomText";
import DashBoardTable from "./DashBoardTable";
import RecentLoans from "./RecentLoans";
import {
  DrawerView,
  FloatPage,
  Separator,
  context,
} from "../accessories/accessories";
import ScrollContainer from "../accessories/ScrollContainer";
import { WebPageView } from "../accessories/accessories";
import LeftNavBar from "../NavBar/leftNavBar";
import { web } from "../accessories/Platform";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Footer from "../accessories/footer";
import ShareApp from "../NavigationBar/ShareApp";
import LoanContacts from "../NavigationBar/LoanContacts";
import Settings from "../NavigationBar/Setting";
import CalculatorApp from "../NavigationBar/Calculator";
import CalculatorMenu from "../accessories/CalculatorMenu";
import Payment from "../Payment/Payment.js";
import ContactCard from "./ContactCard";

let iRecentLoansCount = -1;
const isMobileWeb = Dimensions.get("window").width <= 480;

const DashBoard = (props) => {
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { navigation, userName = "" } = contextDetails;

  const SessionId = contextDetails["SessionId"] || props["SessionId"];
  const [floatPage, setFloatPage] = useState(null);
  const [processingStatus, setProcessingStatus] = useState(null);
  const [webPageURL, setWebPageURL] = useState(null);
  const [recentLoans, setRecentLoans] = useState(null);
  const [WebLoginId, setWebLoginId] = useState(null);
  const [screenSize, setScreenSize] = useState(
    web ? [window.innerWidth, window.innerHeight] : [0, 0]
  );
  const [taskDetails, setTaskDetails] = useState({
    activeRowData: null,
    completeRowData: null,
  });
  const [UserId, setUserId] = useState(0);
  const [partnerInfo, setPartnerInfo] = useState(null);
  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [partnerId, setPartnerId] = useState(null);
  const [loId, setLoId] = useState(null);

  const loanOfficerId =
    contextDetails["loanofficer"] || contextDetails["loanOfficerId"] || 0;
  const PartnerId = contextDetails["PartnerId"] || 0;

  useEffect(() => {
    setPartnerId(PartnerId);
    setLoId(loanOfficerId);
  }, [PartnerId, loanOfficerId]);

  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    (navigation || props["navigation"]).navigate(path, option || {});
  };
  const handleLogOut = (isClear) => {
    handleAPI({
      name: "LogOutSession",
      params: { SessionId: SessionId },
    })
      .then((response) => {
        handleClearState();
        if (isClear) AsyncStorage.removeItem("Credentials");
        let Path = web ? "Login" : "StartScreen";

        setContextDetails((prevContextDetails) => {
          return { ...prevContextDetails, Path };
        });
        navigate(Path);
      })
      .catch((err) => console.error("Error from LogOutSession ====> ", err));
  };
  const handleClearState = (isDelate) => {
    log("State was Cleared", "DashBoard", isDelate);
    setWebPageURL(null);
    setTaskDetails({
      activeRowData: null,
      completeRowData: null,
    });
    setRecentLoans([]);
    iRecentLoansCount = -1;
    let iContextDetails = contextDetails;
    delete iContextDetails["firstActiveLoan"];
    if (!isDelate) delete iContextDetails["SessionId"];
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...iContextDetails };
    });
  };

  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      () => {
        return true;
      }
    );
    return () => backHandler.remove();
  }, []);

  useEffect(() => {
    if (SessionId) {
      handleGetUserTask(1);
    }
  }, [SessionId]);

  useEffect(() => {
    if (partnerId && loId) {
      handleGetContactInfo();
    }
  }, [partnerId, loId]);

  useEffect(() => {
    let { from = "", flag = "" } = props?.route?.params || {};
    if (SessionId && from == "Home") {
      handleGetUserTask(5);
    }
    if (flag == "changeActiveIndex") {
      setProcessingStatus(flag);
    }
  }, [props]);

  const handleGetContactInfo = async () => {
    await handleAPI({
      name: "GetPartnerAndEmployeeJson",
      params: {
        PartnerId: partnerId,
        EmpNumber: loId,
      },
    })
      .then((response) => {
        try {
          // const data = JSON.parse(response);
          // console.log(data);
          // const partnerData = JSON.parse(data?.PartnerJson || "{}");
          // const employeeData = JSON.parse(data?.EmployeeJson || "{}");

          // Update individual state variables
          setPartnerInfo(response["PartnerJson"] || "");
          setEmployeeInfo(response["EmployeeJson"] || "");
        } catch (error) {
          console.error("Error parsing API response:", error);
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
      });
  };

  const handleGetUserTask = async (taskPoolCount) => {
    setProcessingStatus("gettingUserTask");
    log("GetUsertasks - taskPoolCount", taskPoolCount);

    await handleAPI({
      name: "GetUsertasks",
      params: {
        SessionId: SessionId,
      },
    })
      .then((response) => {
        try {
          let data = JSON.parse(response),
            activeRowData = data["Table"] || [],
            completeRowData = data["Table1"] || [];
          if (
            (data &&
              data["Message"] !== "An error has occurred." &&
              JSON.stringify(data) != "{}" &&
              (completeRowData.length > 0 || activeRowData.length > 0)) ||
            taskPoolCount >= 5 ||
            iRecentLoansCount === 0
          ) {
            activeRowData = removeDuplicates(activeRowData, "TaskAssigned");
            completeRowData = removeDuplicates(completeRowData, "TaskAssigned");

            setTaskDetails({
              ...{
                activeRowData,
                completeRowData,
              },
            });
            setProcessingStatus(null);
          } else if (taskPoolCount <= 5 && iRecentLoansCount !== 0) {
            setTimeout(() => {
              handleGetUserTask(taskPoolCount + 1);
            }, 3000);
          }
        } catch (error) {}
      })
      .catch((error) => {
        console.error("Error from GetUserTasks ====> ", error);
      });
  };

  useEffect(() => {
    // handleClearState();

    handleLogDWCallToActionEventParent(
      "Borrower_DashBoard",
      "LogDWVisitorsEvent",
      "Borrower DashBoard",
      { SessionId, Email: "" }
    );
    handleGetRecentLoans();
    let iContextDetails = contextDetails;
    delete iContextDetails["loanId"];
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...iContextDetails };
    });
  }, [props]);

  useEffect(() => {
    (async () => {
      let iUserId = await handleSessionCheck(SessionId, () => {});
      setUserId(iUserId);
    })();
  }, [SessionId]);

  const handleGetRecentLoans = () => {
    handleAPI({
      name: "GetWelcomePageDetails",
      params: { SessionId: SessionId },
    })
      .then((response) => {
        response = JSON.parse(response)["Table"];
        // response = removeDuplicates(response, "loanId");
        setRecentLoans(response);
        iRecentLoansCount = response.length;

        if (iRecentLoansCount === 0) {
          setTaskDetails({
            ...{
              activeRowData: [],
              completeRowData: [],
            },
          });
        } else {
          let firstActive = response.filter(
            (loanDetails) => Number(loanDetails["Active"]) === 1
          );
          if (firstActive.length > 0) {
            setContextDetails((prevContextDetails) => {
              return {
                ...prevContextDetails,
                firstActiveLoan: firstActive[0]["LoanId"],
              };
            });
          }
        }
      })
      .catch((err) =>
        console.error("Error from GetWelcomePageDetails ====> ", err)
      );
  };

  const prePre = async () => {
    try {
      let data = await handleGetEmpDetails(SessionId);

      if (data && data["Message"] !== "An error has occurred.") {
        data = JSON.parse(data);
        let userName = data["Table4"][0]["EmpNum"],
          userType = data["Table1"][0]["Type"];
        userName = userName.replaceAll("undefined", "") || "";
        setContextDetails((prevContextDetails) => {
          return { ...prevContextDetails, ...{ userName, userType } };
        });
      }
    } catch (error) {}
    if (web) {
      function updateSize() {
        // console.log("updateSize");
        setScreenSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }
  };
  useEffect(() => {
    prePre();
    handleGetWebLoginId();
  }, [SessionId]);

  const handleGetWebLoginId = async () => {
    try {
      let iWebLoginId = await handleUserDetails(SessionId);
      iWebLoginId = iWebLoginId.split("~");
      setWebLoginId(Number(iWebLoginId[6]));
      setContextDetails((prevContextDetails) => {
        return { ...prevContextDetails, Email: iWebLoginId[4] };
      });
    } catch (error) {}
  };
  let isSmallScreen =
    (web && screenSize[0] > 900) ||
    (web && Dimensions.get("window").width > 900);

  return (
    <>
      <NavBar
        setFloatPage={setFloatPage}
        WebLoginId={WebLoginId}
        handleLogOut={handleLogOut}
        isDashBoard={true}
        handleClearState={handleClearState}
        userName={userName}
        navigation={navigation || props["navigation"]}
        isSmallScreen={false}
        pageIndex={{ page: 0, sunPage: 0 }}
      />
      <View style={{ flex: 1, flexDirection: "row", overflow: "hidden" }}>
        {isSmallScreen && (
          <>
            <LeftNavBar
              handleLogOut={handleLogOut}
              isDashBoard={true}
              handleClearState={handleClearState}
              navigation={navigation || props["navigation"]}
            />
          </>
        )}

        <>
          {webPageURL ? (
            <WebPageView url={webPageURL} />
          ) : (
            <View
              style={[
                styles.container,
                isSmallScreen && {
                  left: 350,
                },
              ]}
            >
              <ScrollContainer
                pullDownRefresh={async () => {
                  handleGetRecentLoans();
                  await handleGetUserTask(0);
                }}
              >
                <>
                  <>
                    <CustomText
                      bold={true}
                      style={{ fontSize: 25, marginTop: 10, marginBottom: 5 }}
                    >
                      Welcome, {userName}
                      {userName && "!"}
                    </CustomText>
                    <CustomText style={{ fontSize: web ? 18 : 15 }}>
                      Congratulations for going Direct! What would you like to
                      do next?
                    </CustomText>
                    {/* Add ContactsSection here - only shows if partnerId exists */}
                    {partnerId && (
                      <ContactCard
                        partnerInfo={partnerInfo}
                        employeeInfo={employeeInfo}
                      />
                    )}
                  </>
                  <DashBoardTable
                    setProcessingStatus={setProcessingStatus}
                    setWebPageURL={setWebPageURL}
                    taskDetails={taskDetails}
                    processingStatus={processingStatus}
                    navigation={navigation || props["navigation"]}
                    handleGetUserTask={(taskPoolCount) => {
                      if ((recentLoans || []).length) {
                        handleGetUserTask(taskPoolCount);
                      }
                    }}
                    setFloatPage={setFloatPage}
                  />
                  <View>
                    <Separator />
                    <RecentLoans
                      // isExpand={
                      //   recentLoans !== null && recentLoans.length === 0
                      // }
                      setFloatPage={setFloatPage}
                      isExpand={
                        (taskDetails["activeRowData"] || []).length === 0
                      }
                      recentLoans={recentLoans || []}
                      navigation={navigation || props["navigation"]}
                    />
                  </View>
                </>
              </ScrollContainer>

              {!isMobileWeb && web && navigate && (
                <View style={{ marginTop: 10, width: 700 }}>
                  <Footer
                    setFloatPage={setFloatPage}
                    iLoanId={
                      (taskDetails?.activeRowData &&
                        taskDetails?.activeRowData[0]?.loanid) ||
                      (taskDetails?.completeRowData &&
                        taskDetails?.completeRowData[0]?.loanid)
                    }
                    navigate={navigate}
                    From="DashBoard"
                    UserId={UserId}
                    userName={userName}
                    SessionId={SessionId}
                  />
                </View>
              )}
            </View>
          )}
        </>
      </View>
      {(!web || isMobileWeb) && navigate && (
        <Footer
          iLoanId={
            (taskDetails?.activeRowData &&
              taskDetails?.activeRowData[0]?.loanid) ||
            (taskDetails?.completeRowData &&
              taskDetails?.completeRowData[0]?.loanid)
          }
          navigate={navigate}
          From="DashBoard"
          UserId={UserId}
          userName={userName}
          setFloatPage={setFloatPage}
          SessionId={SessionId}
        />
      )}

      {web && floatPage && (
        <DrawerView
          onClose={() => {
            setFloatPage(null);
          }}
          bodyStyle={
            web && !isMobileWeb ? floatPage?.["option"]?.["style"] : {}
          }
          isShow={floatPage?.["path"] ? true : false}
          From="DashBoard"
          isSmallScreen={isSmallScreen}
          needHeaderContent={true}
          body={
            floatPage?.["path"] == "ShareApp" ? (
              <ShareApp
                route={{ params: floatPage?.["option"], SessionId }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "LoanContacts" ? (
              <LoanContacts
                from="DashBoard"
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "Settings" ? (
              <Settings
                from="DashBoard"
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "Calculator" ? (
              <CalculatorApp
                From="Home"
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
                LoanId={
                  (taskDetails?.activeRowData &&
                    taskDetails?.activeRowData[0]?.loanid) ||
                  (taskDetails?.completeRowData &&
                    taskDetails?.completeRowData[0]?.loanid)
                }
              />
            ) : floatPage?.["path"] === "CalculatorMenu" ? (
              <CalculatorMenu
                navigation={navigation || props["navigation"]}
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : floatPage?.["path"] === "Payment" ? (
              <Payment
                navigation={navigation || props["navigation"]}
                route={{ params: floatPage?.["option"] }}
                setFloatPage={setFloatPage}
              />
            ) : (
              floatPage?.["body"] || null
            )
          }
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
    marginTop: -5,
    borderRadius: 10,
    boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
  },
  buttonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 5,
    borderWidth: 1,
    alignSelf: "flex-start",
    paddingHorizontal: !isMobileWeb && web ? 15 : 5,
    paddingVertical: !isMobileWeb && web ? 10 : 6,
    marginRight: !isMobileWeb && web ? 0 : 10,
    borderColor: "#262626",
    backgroundColor: "#595959",
  },
  card: {
    backgroundColor: "#f2f2f2",
    padding: 10,
    marginBottom: 10,
    borderColor: "#0275d8",
    borderWidth: 1,
    borderRadius: 5,
    width: 700,
  },
  row: {
    flexDirection: "row",
  },
  column: {
    flex: 1,
    paddingLeft: 0,
  },
  label: {
    fontSize: 12,
    fontWeight: 800,
    marginBottom: 2,
  },
  value: {
    fontSize: 14,
  },
  creditText: {
    fontSize: 12,
    color: "red",
  },
});
export default DashBoard;
